<!-- 旅游攻略详情页 -->
<template>
 <div class="travelServe travelDetailcontainer pb100">
    <!-- <div class="banner-1">
      <img src="../../assets/1/images/banner_szzy.jpg" alt="">
    </div> -->
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">旅游攻略</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
  <crumbs detail="true"/>
    <div class="container">
      <div class="guideDetail">
        <div class="title">
          <div class="txt">
            <img :src="detailInfo.image" alt="">
            <h2>{{detailInfo.title}}</h2>
            <p>
              <!-- <span>更新时间：2021-03-11 21:50:46.0</span> -->
              <span v-if="detailInfo.source !== undefined && detailInfo.source !== ''">来自：{{detailInfo.source}}</span>
              <!-- <span>类型：{{detailInfo.}}} </span> -->
           </p>
          </div>
           <p class="iconBox">
              <pv :pvtype=1 :count=pv></pv>
           </p>
        </div>
        <div class="detailbanner" id="detailbanner">
           <swiper :options="swiperOption" class="swipercontainer">
              <!-- <div class="swiper-wrapper" id="attractions"> -->
                <swiper-slide class="swiper-slide " v-for="(item,index) in detailInfo.travelImageList" :key="index" >
                   <div class="inner">
                      <div class="imgbox" @click="goLink(item.travelUrl)">
                           <img :src="item.imageUrl" alt="">
                      </div>
                      <h2>{{item.name}}</h2>
                   </div>
                   <div class="bottomimg"></div>
                </swiper-slide>
              <!-- </div> -->
            </swiper>
        </div>

        <div class="contentdetail" v-html="detailInfo.content">
        </div>

      <!-- 评论 组件引入 -->
      <comment v-if="detailInfo" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
      </div>
      <right-sidebar @pvcount="pvcount" :comment-count="commentTotal" :comment-gotop="commentOffsettop" :comment-show="isCommentshow" ref="rightSidebar"
       :title="detailInfo.title"
      :image="getImage(detailInfo.image)"
      :url="this.$route.fullPath"
      ></right-sidebar>
       <go-top></go-top>
      </div>
    </div>
</template>

<script>
import pv from '@/components/amount/pv'
import crumbs from '@/components/crumbs/index'
import {getGuidedetail} from '@/api/travelguide/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'travelguidedetail',
  components: {
    Comment,
    swiper,
    swiperSlide,
    RightSidebar,
    goTop,
    crumbs,
    pv
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      commentId: 1,
      id: '',
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 0,
        // loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      detailInfo: {},
      pv: '',
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true
    }
  },
  created () {
    console.log(this.$route.query)
    this.id = this.$route.query.id
    this.getdetail()
  },
  methods: {
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getdetail () {
      getGuidedetail(this.id).then(res => {
        console.log(res)
        this.detailInfo = res.data.data
      })
    },
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    commentCount (val) {
      this.commentTotal = val
    },
    pvcount (val) {
      this.pv = val
    },
    goLink (url) {
      console.log(url)
      window.open(url)
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
</style>



// WEBPACK FOOTER //
// src/view/travelguide/detail.vue